// =============================================
// NotesMedia — a TipTap block node that embeds an uploaded image/video by id.
// =============================================
// The document JSON stores ONLY a stable reference (mediaId + kind + name) — never
// bytes, never a token-bearing URL. The React NodeView resolves the id to a live
// src at render time (see MediaNodeView). atom = treated as a single opaque unit.
// =============================================
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import MediaNodeView from './MediaNodeView';

export const NotesMedia = Node.create({
  name: 'notesMedia',
  group: 'block',
  atom: true,
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      mediaId: { default: null },
      kind: { default: 'image' }, // 'image' | 'video' | 'drawing'
      mime: { default: null },
      name: { default: null },
      rev: { default: 0 },        // bumped after a drawing re-edit to force a refetch
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-notes-media]' }];
  },

  renderHTML({ HTMLAttributes }) {
    // Serialized form (e.g. copy/paste) keeps the reference attributes only.
    return ['div', mergeAttributes(HTMLAttributes, {
      'data-notes-media': '',
      'data-media-id': HTMLAttributes.mediaId,
      'data-kind': HTMLAttributes.kind,
    })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(MediaNodeView);
  },
});
